import React from 'react'
import ProductCard from './ProductCard';

function ProductGrid({ products, selectedCategory = 'all' }) {
  const filteredProducts = selectedCategory === 'all'
    ? products
    : products.filter((product) => product.category === selectedCategory);

  return (
    <div id="produkti">
      {filteredProducts.length === 0 && <p>...</p>}
      <div className="product-grid padding-20-bottom">
        {filteredProducts.map((product) => (
          <ProductCard key={product._id} product={product} />
        ))}
      </div>
    </div>
  )
}

export default ProductGrid
